import { ReactNode } from 'react';
import { Button, Icons } from 'ui-kit';
import styles from './Footer.module.scss';

interface FooterProps {
  version: ReactNode;
  phone?: string | null;
  tg?: string;
  max?: string;
  helpdeskInfo?: ReactNode;
}

export function Footer({ version, phone, tg, max, helpdeskInfo }: FooterProps) {
  return (
    <footer className={styles.footer}>
      {phone && (
        <a
          href={`tel:${phone}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.phone}
        >
          {phone}
        </a>
      )}
      {helpdeskInfo}
      {!![tg, max].filter(Boolean).length && (
        <div className={styles.buttons}>
          {tg && (
            <Button
              variant="big"
              as="a"
              href={tg}
              target="_blank"
              className={styles.messengerButton}
            >
              <Icons.TGLogo />
              Telegram
            </Button>
          )}
          {max && (
            <Button
              variant="big"
              as="a"
              href={max}
              target="_blank"
              className={styles.messengerButton}
            >
              <Icons.MaxLogo className={styles.max} />
            </Button>
          )}
        </div>
      )}
      <span>{version}</span>
    </footer>
  );
}

export const MAX_COUNTRIES = ['ru', 'by'];
